import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextSize"><Path d="M6.92969 20.5V10.999" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M22.5 4.5H9.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M12.5 11H1.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M16 5V20.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTextSize;
